export enum PaymentMethod {
  CREDIT_CARD = 'credit-card',
  PIX = 'pix',
  BANKSLIP = 'bankslip',
  DEFAULT_CREDIT_CARD = 'default-credit-card',
  NU_PAY = 'nu-pay',
  CREDIT_CARD_IN_PERSON = 'credit-card-in-person',
  PIX_IN_PERSON = 'pix-in-person',
  CASH = 'cash',
  CHEQUE = 'cheque',
  CREDIT_CARD_PLUS_CREDIT_CARD = 'credit-card+credit-card',
  APPLE_PAY = 'apple-pay',
  GOOGLE_PAY = 'google-pay',
}
